import { StyleSheet } from 'react-native';
import { Colors, grid } from '@shared/styles';

export const SELECTED_CHANNEL_IMAGE_SIZE = grid(10);
export const Styles = StyleSheet.create({
  horizontalUserListRowImage: {
    width: 56,
    height: 56,
    borderRadius: 56 / 2,
    borderWidth: 4,
    borderColor: 'white',
    overflow: 'hidden',
  },
  horizontalUserListRowText: {
    maxWidth: 56,
  },
  selectChannelImageWrapper: {
    width: grid(9),
    height: grid(9),
    borderRadius: grid(9) / 2,
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: Colors.v2.green,
  },
  selectedChannelImageWrapper: {
    width: SELECTED_CHANNEL_IMAGE_SIZE,
    height: SELECTED_CHANNEL_IMAGE_SIZE,
    borderRadius: SELECTED_CHANNEL_IMAGE_SIZE / 2,
    overflow: 'hidden',
    position: 'relative',
  },
  detailsUserList: {
    flexWrap: 'wrap',
  },
  channelImageSelectorWrapper: {
    height: grid(20),
    backgroundColor: Colors.v2.gray05,
  },
  formColor: {
    backgroundColor: Colors.v2.white,
  },
  fillColor: {
    backgroundColor: Colors.v2.gray05,
  },
  imageSelectorPadding: {
    paddingHorizontal: '12.5%',
  },
});
